// extracted by mini-css-extract-plugin
module.exports = {"galleryPage":"PhotoGalleryPage_galleryPage__36TXn"};